import React from 'react';
import { Box, Typography, Stack, Chip, Divider, useTheme } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import {
	BID_STATUS_COLORS,
	BID_STATUS_LABELS,
	BID_REASONS,
} from '../../../../Shared/bids';
import SectionHeader from './SectionHeader';
import { formatCurrency } from '../../../../Shared/stripeFee';
import { surfaceCard } from '../../../../Shared/surfaceCard';

const BidHistoryPanel = ({ bids }) => {
	const theme = useTheme();

	if (!bids || bids.length <= 1) return null;

	return (
		<Box
			sx={{
				...surfaceCard(theme),
				display: 'flex',
				flexDirection: 'column',
				maxHeight: 320,
				minHeight: 0,
			}}
		>
			<SectionHeader icon={HistoryIcon} title="Bid History" />
			<Divider sx={{ opacity: 0.6 }} />
			<Stack
				spacing={0}
				sx={{
					flex: 1,
					minHeight: 0,
					overflowY: 'auto',
					px: { xs: 2, sm: 2.5 },
					py: 1,
				}}
			>
				{bids.map((bid, index) => (
					<Box
						key={bid.id}
						sx={{
							py: 1.5,
							borderBottom: index === bids.length - 1 ? 'none' : '1px solid',
							borderColor: 'divider',
						}}
					>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'flex-start',
								gap: 1,
								flexWrap: 'wrap',
							}}
						>
							<Box sx={{ minWidth: 0 }}>
								<Typography
									variant="caption"
									color="text.secondary"
									display="block"
								>
									{new Date(bid.created_at).toLocaleString(undefined, {
										dateStyle: 'medium',
										timeStyle: 'short',
									})}
								</Typography>
								<Typography variant="body2" fontWeight={500} sx={{ mt: 0.25 }}>
									{BID_REASONS[bid.reason]}
								</Typography>
							</Box>
							<Chip
								label={BID_STATUS_LABELS[bid.status]}
								size="small"
								color={BID_STATUS_COLORS[bid.status]}
								variant="outlined"
								sx={{ height: 22, fontSize: '0.7rem', fontWeight: 600 }}
							/>
						</Box>
						<Typography
							variant="body1"
							fontWeight={700}
							color="primary.main"
							sx={{ mt: 0.75, fontVariantNumeric: 'tabular-nums' }}
						>
							${formatCurrency(bid.amount)}
						</Typography>
					</Box>
				))}
			</Stack>
		</Box>
	);
};

export default BidHistoryPanel;
